import { BaseAction } from './action.base';
import { ActionType } from './action.type';

/**
 * Action is callback toggle that have two states:
 * - true: if active
 * - false: if not active
 */
export class ToggleAction extends BaseAction {
  // It is responsible for toggle state
  private _toggleState: boolean;

  constructor(
    public icon: string,
    public title: string,
    private callback: (toggle: boolean) => void
  ) {
    super(icon, title);
    this._toggleState = false;
  }

  /**
   * @method toggle
   * Switches toggle state and triggers the callback if it is available
   */
  toggle(): void {
    if (this.isEnable()) {
      this._toggleState = !this._toggleState;
      this.callback(this._toggleState);
    }
  }

  /**
   * @method isToggle
   * @return toggle state
   */
  isToggle(): boolean {
    return this._toggleState;
  }

  /**
   * @method type
   * @returns action type
   */
  type(): ActionType {
    return ActionType.TOGGLE;
  }

  setToggle(state: boolean): void {
    this._toggleState = state;
  }
}
